import React from "react";
import { Lock, ArrowRightLeft, Coins, Bike } from "lucide-react";
import { Placeholder } from "./Placeholder";

const points = [
  {
    icon: Lock,
    title: "Details for the driver",
    body:
      "Full address, building or unit info, and delivery instructions are kept private and surfaced only to whoever is actually driving, at the moment the delivery needs to happen.",
  },
  {
    icon: ArrowRightLeft,
    title: "A clear handoff point",
    body:
      "You're brought in once a vendor marks an order ready for dispatch. Pick up from the vendor, deliver to the recipient. No ambiguity.",
  },
  {
    icon: Coins,
    title: "Paid per delivery",
    body:
      "A fair per-delivery payout calculated from distance and effort, separate from the vendor's own payout. You see what you'll earn before you accept.",
  },
];

export const ForDrivers = () => {
  return (
    <section
      id="for-drivers"
      data-testid="for-drivers-section"
      className="liea-section"
      style={{ background: "var(--liea-paper)" }}
    >
      <div className="liea-container grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <span className="liea-eyebrow">For drivers & couriers</span>
          <h2 className="mt-4 text-[36px] md:text-[48px] lg:text-[52px] leading-[1.05] tracking-tight">
            The{" "}
            <em
              style={{
                fontStyle: "italic",
                color: "var(--liea-forest)",
              }}
            >
              last mile
            </em>
            , done with care
            <span style={{ color: "var(--liea-terracotta)" }}>.</span>
          </h2>
          <p
            className="mt-5 text-base md:text-lg leading-relaxed"
            style={{ color: "var(--liea-warm-grey)" }}
          >
            Drivers are at the heart of Liéa&rsquo;s network, supported by
            seamless handoffs, protected privacy, and fair pay.
          </p>

          <div className="mt-9">
            <Placeholder
              testId="driver-placeholder"
              label="Driver delivery handoff"
              aspect="5/4"
            />
          </div>
        </div>

        <div className="lg:col-span-7 lg:pl-6">
          <div className="space-y-6">
            {points.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={p.title}
                  data-testid={`driver-point-${i + 1}`}
                  className="flex gap-5 p-6 rounded-2xl"
                  style={{
                    background: "#ffffff",
                    border: "1px solid rgba(149, 159, 133, 0.22)",
                  }}
                >
                  <div
                    className="shrink-0 w-11 h-11 rounded-full flex items-center justify-center"
                    style={{
                      background: "rgba(64, 83, 68, 0.08)",
                      color: "var(--liea-forest)",
                    }}
                  >
                    <Icon size={20} strokeWidth={1.7} />
                  </div>
                  <div>
                    <h3 className="text-[22px] leading-snug">{p.title}</h3>
                    <p
                      className="mt-2 text-[15px] leading-relaxed"
                      style={{ color: "var(--liea-warm-grey)" }}
                    >
                      {p.body}
                    </p>
                  </div>
                </div>
              );
            })}

          </div>
        </div>
      </div>
    </section>
  );
};

export default ForDrivers;
